import { useEffect } from 'react'
import { useRouter } from '@tanstack/react-router'
import { AppShell } from '@ui/shell/AppShell'
import { useAuth } from './auth-context'
import { Interstitial, Waiting } from './Interstitial'

/**
 * O portão das rotas do app. Só o estado `ready` — autenticado **e** com a casa
 * preparada — chega a renderizar conteúdo.
 *
 * Sem sessão, leva ao login com o destino junto, para que o deep link de
 * notificação da Fase 6 sobreviva ao login em vez de virar a home.
 */
export function RequireAuth() {
  const { session } = useAuth()
  const router = useRouter()
  const signedOut = session.status === 'signedOut'

  useEffect(() => {
    if (!signedOut) return

    // Por que um efeito, e não `<Navigate to="/entrar" search={{ destino }} />`:
    // o `Navigate` do TanStack renavega sempre que a **identidade** do objeto
    // de props muda (ele guarda `previousPropsRef.current !== props`), e um
    // `search` montado no render é um objeto novo a cada render. Com o destino lido da localização atual, cada
    // navegação alimentava a seguinte e o `destino` crescia embutido em si
    // mesmo até o processo de teste morrer por falta de memória — foi assim que
    // isto apareceu, e não por leitura.
    //
    // O destino é lido AQUI, quando a sessão vira "deslogada", e não no render:
    // neste instante a URL ainda é a rota protegida que a pessoa pediu.
    const destino = router.state.location.href
    void router.navigate({ to: '/entrar', search: { destino }, replace: true })
  }, [signedOut, router])

  switch (session.status) {
    case 'ready':
      return <AppShell />
    case 'signedOut':
      // Nada de conteúdo enquanto a navegação para o login acontece.
      return <Waiting label="Levando para a entrada" quiet />
    case 'loading':
    case 'preparing':
    case 'unprepared':
      return <Interstitial session={session} />
  }
}
